<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div class="mt-1" v-else>
            <v-row>
                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">Dashboard</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col cols="12" md="6" lg="6" xl="6" class="input-search-dashboard">
                    <div class="ma-2 d-flex justify-end">
                        <v-form-group class="mr-2">
                            <v-autocomplete color="#D6BFAF" background-color="#fff" v-model="select_mounth"
                                :items="select_item_mounth" item-text="name" item-value="id" hide-details="auto"
                                label="เดือน" @input="getDashboard()" outlined deletable-chips></v-autocomplete>
                        </v-form-group>
                        <v-form-group>
                            <v-select color="#D6BFAF" background-color="#fff" v-model="select_year"
                                :items="select_item_year" item-text="name" item-value="year"
                                :rules="[v => !!v || 'กรุณาเลือกปี พ.ศ.']" @input="getDashboard()" hide-details="auto"
                                label="ปี พ.ศ." outlined deletable-chips></v-select>
                        </v-form-group>
                    </div>
                </v-col>
            </v-row>

            <div class="mt-1">

                <v-row>
                    <v-col cols="12">
                        <div class="ma-5">
                            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
                                <div class="tag_header_profile d-flex">
                                    <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                                        style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                        <div class="logo_timeline mx-auto my-auto">
                                            <img width="25" height="25" src="@/assets/arin_assets/bill_s.png">
                                        </div>
                                    </div>
                                    <v-card elevation="3" class="card_title ml-n5">
                                        <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5 pt-3">
                                            <div>ยอดขายรายเดือน {{ select_item_mounth.find(o => o.id  == select_mounth)?.name }} {{ select_item_year.find(o => o.year  == select_year)?.year + 543 }}</div>
                                        </div>
                                    </v-card>
                                </div>

                                <div class="my-4">
                                    <v-row>
                                        <v-col cols="12" class="title_page_space" style="border-right: 1px solid #D4D4D4;"
                                            md="5" lg="5" xl="5">
                                            <div>
                                                <div class="font-38 bold color_brown">{{
                                                    data_dashboard_round_list.count_order ?
                                                    data_dashboard_round_list.count_order : 0 }}</div>
                                                <div class="text-grey font-18 bold">จำนวนออเดอร์</div>
                                            </div>
                                            <div>
                                                <div class="font-38 bold color_green">{{
                                                    data_dashboard_round_list.total_amount ?
                                                    formatPrice(data_dashboard_round_list.total_amount) : 0 }} บาท</div>
                                                <div class="text-grey font-18 bold">ยอดขาย</div>
                                            </div>
                                        </v-col>

                                        <v-col cols="12" class="title_page_space" md="7" lg="7" xl="7">
                                            <div>
                                                <label class="bold color_brown">ยอดเงินที่ได้รับ</label>
                                                <div class="mt-2 font-24 bold">{{ data_dashboard_round_list.total_cash ?
                                                    formatPrice(data_dashboard_round_list.total_cash) : 0 }}</div>
                                                <div class="text-grey font-16 bold">ยอดเงินสด</div>
                                            </div>
                                            <div class="pt-8">
                                                <div class="mt-2 font-24 bold">{{ data_dashboard_round_list.total_payment ?
                                                    formatPrice(data_dashboard_round_list.total_payment) : 0 }}</div>
                                                <div class="text-grey font-16 bold">ยอดเงินโอน</div>
                                            </div>
                                            <div class="pt-8">
                                                <div class="mt-2 font-24 bold">{{ data_dashboard_round_list.total_qr ?
                                                    formatPrice(data_dashboard_round_list.total_qr) : 0 }}</div>
                                                <div class="text-grey font-16 bold">ยอดเงิน QR CODE</div>
                                            </div>
                                            <div class="pt-8">
                                                <div class="mt-2 font-24 bold">{{ data_dashboard_round_list.total_credit ?
                                                    formatPrice(data_dashboard_round_list.total_credit) : 0 }}</div>
                                                <div class="text-grey font-16 bold">ยอดบัตรเครดิต</div>
                                            </div>
                                            <div class="pt-8">
                                                <div class="mt-2 font-24 bold">{{ data_dashboard_round_list.total_etc ?
                                                    formatPrice(data_dashboard_round_list.total_etc) : 0 }}</div>
                                                <div class="text-grey font-16 bold">ยอดอื่น ๆ</div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <div class="ma-5">
                            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
                                <div class="tag_header_profile d-flex">
                                    <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                                        style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                        <div class="logo_timeline mx-auto my-auto">
                                            <img width="25" height="25" src="@/assets/arin_assets/chart.png">
                                        </div>
                                    </div>
                                    <v-card elevation="3" class="card_title ml-n5">
                                        <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5 pt-3">
                                            <div>ยอดขายรายเดือน</div>
                                        </div>
                                    </v-card>
                                </div>
                                <div class="mt-5">
                                    <div class="d-flex justify-center align-center" style="height:300px;">
                                        <canvas id="myChart"></canvas>
                                    </div>
                                </div>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <div class="ma-5">
                            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
                                <div class="tag_header_profile d-flex">
                                    <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                                        style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                        <div class="logo_timeline mx-auto my-auto">
                                            <img src="@/assets/arin_assets/box.png">
                                        </div>
                                    </div>
                                    <v-card elevation="3" class="card_title ml-n5">
                                        <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5 pt-3">
                                            <div>สินค้าขายดี 10 อันดับ</div>
                                        </div>
                                    </v-card>
                                </div>

                                <div class="my-4">
                                    <v-row>
                                        <v-col cols="12">
                                            <template>
                                                <v-simple-table>
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center font-16">
                                                                    อันดับ
                                                                </th>
                                                                <th class="text-left font-16">
                                                                    ชื่อสินค้า
                                                                </th>
                                                                <th class="text-center font-16">
                                                                    จำนวน
                                                                </th>
                                                                <th class="text-center font-16">
                                                                    หน่วยนนับ
                                                                </th>
                                                                <th class="text-center font-16">
                                                                    ยอดขาย
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index ) in data_dashboard_product_list"
                                                                :key="index">
                                                                <td class="text-center font-16">{{ index + 1 }}</td>
                                                                <td class="font-16">{{ item.product_code + ' - ' +
                                                                    item.product_name }}</td>
                                                                <td class="text-center font-16">{{
                                                                    formatPrice(item.count_sale) }}</td>
                                                                <td class="text-center font-16">{{ item.unit_name == null ?
                                                                    '-' : item.unit_name }}</td>
                                                                <td class="text-center font-16">{{
                                                                    formatPrice(item.total_sale) }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>
                <!-- ข่าวสารใหม่ -->
                <v-dialog v-model="detail_news" persistent max-width="900">
                    <v-card class="">
                        <div class="d-flex justify-space-between">
                            <v-card-title class="bold mx-2">
                                ข่าวสาร & ประชาสัมพันธ์
                            </v-card-title>
                        </div>
                        <v-slide-group v-model="new_model" class="pa-4" show-arrows>
                            <v-slide-item v-for="(new_model, index) in promotion_data.length" :key="index"
                                v-slot="{ active, toggle }">
                                <v-btn :color="active ? '#D6BFAF' : 'grey lighten-1'" class="mx-2" @click="toggle" depressed
                                    rounded dark>ข่าวสารที่ {{ new_model }}</v-btn>
                            </v-slide-item>
                        </v-slide-group>
                        <v-card-text>
                            <v-expand-transition>
                                <v-sheet v-if="new_model != null" tile>
                                    <div class="bold pa-5 pb-1">
                                        รายละเอียด
                                    </div>
                                    <v-row class="pa-5 pb-1">
                                        <v-col cols="12" class="py-1">
                                            <div class="font-16">
                                                <span class="color-grey">พาดหัวข่าว : </span> {{ promotion.title }}
                                            </div>
                                        </v-col>
                                        <v-col cols="12" class="py-1 mt-2">
                                            <div class="font-16">
                                                <span class="color-grey">รายละเอียดข่าวสาร : </span>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" class="py-1">
                                            <div class="font-16" v-html="promotion.content"></div>
                                        </v-col>
                                    </v-row>
                                </v-sheet>
                            </v-expand-transition>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <div class="text-center pa-4">
                                <v-btn small large class=" grad-danger-bg white--text mr-3" @click="close_new()"
                                    style="font-size: 18px">
                                    ปิด
                                </v-btn>
                            </div>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </div>
    </div>
</template>
  
<script>
import Chart from "chart.js/auto";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_sale_report",
    data() {
        return {
            loading_page: true,
            dialog_cancel_order: false,
            show_detail_bill_group: false,
            checkbox_all: false,
            checkbox_select: false,
            graph_day_list: [],
            graph_total_amount_list: [],
            select_item_mounth: [
                {
                    id: 1,
                    name: 'มกราคม',
                },
                {
                    id: 2,
                    name: 'กุมภาพันธ์',
                },
                {
                    id: 3,
                    name: 'มีนาคม',
                },
                {
                    id: 4,
                    name: 'เมษายน',
                },
                {
                    id: 5,
                    name: 'พฤษภาคม',
                },
                {
                    id: 6,
                    name: 'มิถุนายน',
                },
                {
                    id: 7,
                    name: 'กรกฎาคม',
                },
                {
                    id: 8,
                    name: 'สิงหาคม',
                },
                {
                    id: 9,
                    name: 'กันยายน',
                },
                {
                    id: 10,
                    name: 'ตุลาคม',
                },
                {
                    id: 11,
                    name: 'พฤศจิกายน',
                },
                {
                    id: 12,
                    name: 'ธันวาคม',
                },
            ],
            select_mounth: null,

            select_item_year: [],

            select_year: null,

            search: '',
            footer_Props: {
                'items-per-page-text': 'รายการต่อหน้า'
            },
            data_dashboard: [],
            data_dashboard_product_list: [],
            data_dashboard_round_list: {},
            data_dashboard_sale_list: [],

            change_data: null,
            date_show: null,
            myChartCost: null,
            sub_menu: [
                {
                    text: 'Dashboard',
                    disabled: false,
                },
            ],
            promotion_data: [],
            detail_news: false,
            new_model: null,
            promotion: {},
        }
    }, methods: {
    async getYear() {
        const currentYear = new Date().getFullYear();

        const years = Array.from({ length: 5 }, (_, index) => ({
            id: index + 1,
            name: `ปี ${currentYear - index}`,
            year: currentYear - index
        }));
        console.log(years)
        this.select_item_year = years;
    },
    link(link) {
        window.location.href = link;
    },
    open_detail_bill_group() {
        this.show_detail_bill_group = true
    },
    close_model_all() {
        this.show_detail_bill_group = false
    },
    change_month(evt) {
        this.select_mounth = evt;
        this.chart()
    },

    formatPrice(number) {
        return formatPrice(number)
    },
    async getPromotion() {
        let config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
            }

        }
        await HTTP_ARIN.get('/news/store/get/list', config).then(async (res) => {
            if (res.data.successful === true) {
                this.promotion_data = await res.data.data;
                if (this.promotion_data.length > 0) {
                    this.detail_news = true
                }
                this.loading_page = false
            }
        }).catch(err => {
        if(err.response.status == 401){
         this.$router.push('/arin/login')
        }
      })
    },
    async getDashboard() {
        this.graph_day_list = []
        this.graph_total_amount_list = []
        let config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
            }

        }
        await HTTP_ARIN.get(`/pos/dashboard?month=${this.select_mounth}&year=${this.select_year}`, config).then((res) => {
            if (res.data.successful === true) {
                this.data_dashboard_product_list = res.data.data.product_list;
                this.data_dashboard_round_list = res.data.data.round_list;
                this.data_dashboard_sale_list = res.data.data.sale_list;

                this.data_dashboard_sale_list.map(data => {
                    this.graph_day_list.push(parseFloat(data.count_day))
                    this.graph_total_amount_list.push(parseFloat(data.total_amount))
                })
            }
            if (this.myChartCost !== null) {
                this.myChartCost.destroy()
            }
            this.chart()
        })
    },

    async close_new() {
        let data = {
            new_list: []
        };
        let config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
            }
        }
        for (let index = 0; index < this.promotion_data.length; index++) {
            data.new_list.push(this.promotion_data[index].id);
        }
        await HTTP_ARIN.post('/news/store/save/view', data, config).then(async (res) => {
            if (res.data.successful === true) {
                this.detail_news = false
            }
        })
    },

    chart() {
        let data = {
            labels: this.graph_day_list,
            datasets: [
                {
                    label: 'ยอดเงิน',
                    data: this.graph_total_amount_list,
                    borderColor: '#D6BFAF',
                    backgroundColor: '#D6BFAF',
                    fill: false,
                },
            ]
        }
        let config = {
            type: 'line',
            data: data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: true
                    },
                    y: {
                        stacked: true
                    }
                }
            }
        }

        const ctx = document.getElementById('myChart').getContext('2d');
        this.myChartCost = new Chart(ctx, config)
    },



    diffDateTH_Arrival(value) {
        const diff = value.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0]) + 543
        const final_date = day + '/' + month + '/' + year
        return this.buy_mounth_function_date = final_date
    },


},
computed: {
    // Compute the current month as a number (0-11)
    calculateCurrentMonth() {
        const currentDate = new Date();
        return currentDate.getMonth();
    },
    calculateCurrentYear() {
        const currentDate = new Date();
        return currentDate.getFullYear();
    },

},
async mounted() {
    await this.getYear()
    await this.getPromotion()
    this.select_mounth = await this.calculateCurrentMonth + 1
    this.select_year = await this.calculateCurrentYear;
    await this.chart()
    await this.getDashboard()
},
watch: {
    page() {
        this.chart()
    },
    calculateCurrentMonth(newMonth) {
        this.select_mounth = newMonth;
    },
    new_model() {
        this.promotion = this.promotion_data[this.new_model]
    }
},

}
</script>
  
<style scoped>
.btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #88B358 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
}

.title_page_space {
    display: flex;
    align-items: center;
    justify-content: space-around;

}

.color_brown {
    color: #84611F;
}

.color_green {
    color: #88B358;
}

.color_red {
    color: #F28080;
}

.card_relative {
    position: relative;
    border-radius: 15px;
}

.profile_detail {
    display: grid;
    grid-template-columns: 30% 70%;
}

.header_half {
    display: grid;
    grid-template-columns: 50% 50%;
}

.logo_timeline {
    width: 25px;
    height: 25px;
}

.logo_timeline>img {
    max-width: 25px;
}

.tag_header_profile {
    position: absolute;
    top: -30px;
    left: -15px;
}

.arin-text-color {
    color: #84611F;
    font-weight: bold;
    font-size: 16px;
}

.arin-text-color-two {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
}

.card_title {
    margin-top: 1px;
    margin-bottom: 1px;
    border-radius: 10px;
    border: 1px solid #D6BFAF;
}

.preview {
    border-radius: 10px;
}

.employee_box {
    border-radius: 10px;
    border: 1px solid #D6BFAF;
    width: auto;
}

.sub_title {
    font-size: 16px;
}

.image_title {
    font-weight: 500;
    font-size: 16px;
}

.picture_details {
    display: grid;
    grid-template-columns: 40% 60%;
}

.mobile_btn {
    width: 40%;
}

.grid_half {
    display: grid;
    grid-template-columns: 50% 50%;
}

.grid_four_ck {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
}

.text_title {
    color: #909090;
    font-weight: bold;
    font-size: 16px;
}

.text_detail {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
}

.text_unit {
    font-size: 20px;
}

.v-application {
    padding: 13px !important;
}

.logo_timeline {
    padding: 0px;
}

.border-bill {
    border: 1px solid #F0F0F0;
}

.border-bill-green {
    border: 1px solid #88B358;
}

.border-style-b {
    /* border-style: dotted;
    border-color: #ADADAD; */
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 1px dotted #ADADAD;
}

.title_page_right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.title_page_center {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.input-search-dashboard {
    display: flex;
    align-items: flex-end;
    margin-bottom: 0;
    padding-bottom: 0;
    justify-content: flex-end;
    padding-right: 23px;
}
</style>
  